import styled from "styled-components";
import { FormSectionProps } from "../../types/common";

export const FormSection = ({
  title,
  children,
  className,
  action,
  ...props
}: FormSectionProps) => {
  return (
    <SectionCard className="radius10">
      <SectionHeader>
        <div className="section-title-group">
          <div className="accent-bar" />
          <span className="section-title">{title}</span>
        </div>
        {action && <div className="section-action">{action}</div>}
      </SectionHeader>
      <ChildWrapper className={`${className || ""}`} {...props}>
        {children}
      </ChildWrapper>
    </SectionCard>
  );
};

const SectionCard = styled.div`
  background: var(--lp-raised);
  border-radius: var(--lp-r-md);
  border: 1px solid var(--lp-border);
  box-shadow: var(--lp-shadow-sm);
  overflow: hidden;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: var(--lp-shadow-md);
  }
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 20px;
  border-bottom: 1px solid var(--lp-border);
  background: var(--lp-bg-alt);

  .section-title-group {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .accent-bar {
    width: 3px;
    height: 18px;
    border-radius: var(--lp-r-pill);
    background: var(--lp-primary);
  }

  .section-title {
    font-size: 13px;
    font-weight: 700;
    color: var(--lp-text);
    text-transform: capitalize;
    letter-spacing: -0.01em;
  }

  .section-action {
    margin-left: auto;
  }
`;

export const ChildWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
  padding: 20px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    padding: 16px;
  }

  .fullWidth {
    grid-column: span 2;
    @media (max-width: 760px) {
      grid-column: 1;
    }
  }

  & > *:only-child {
    grid-column: span 2;
  }

  & > *:nth-last-child(1):nth-child(odd) {
    grid-column: span 2;
    @media (max-width: 760px) {
      grid-column: 1;
    }
  }
`;
